module.exports = __webpack_public_path__ + "img/kultrun.278a52bb.svg";